import React, { useEffect, useState } from 'react';
import { getVersion } from '../apis/verAPI';
import './Footer.css';

const Footer = () => {
  const [versionInfo, setVersionInfo] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchVersion = async () => {
      try {
        const data = await getVersion();
        if (isMounted) setVersionInfo(data);
      } catch (error) {
        console.error('Error fetching version info:', error);
      }
    };

    fetchVersion();

    return () => {
      isMounted = false;
    };
  }, []);

  if (!versionInfo) return null;

  const { mode, version, date, commit } = versionInfo;

  return (
    <footer className="app-footer">
      <hr className="app-footer-divider" />
      <div className="app-footer-text">
        Ver. {mode} {version}.{date} - {commit}
      </div>
    </footer>
  );
};

export default Footer;
